import React from 'react';
import Error from './Error';

const PageNotFound = (props) => <Error props={props} errorType="404" errorCode="404" />;

export default PageNotFound;
